import React, { useEffect, useState } from "react";
import "./Navbar.css";
import { Row, Col, Form, Button } from "react-bootstrap";

const CourseFinderHome = () => {
  const [schools, setSchools] = useState([]);
  const [courses, setCourses] = useState([]);
  const [selectedSchool, setSelectedSchool] = useState("");
  const [selectedCourse, setSelectedCourse] = useState("");

  // Fetch schools on component mount
  useEffect(() => {
    fetch("https://isbmuniversity.edu.in/admin-portal/schoolsApi")
      .then((res) => res.json())
      .then((data) => {
        if (Array.isArray(data)) {
          setSchools(data);
        } else if (data.data && Array.isArray(data.data)) {
          setSchools(data.data);
        }
      })
      .catch((err) => console.error("Error fetching schools:", err));
  }, []);

  // Fetch courses when a school is selected
  useEffect(() => {
    if (selectedSchool) {
      fetch(
        "https://isbmuniversity.edu.in/admin-portal/coursesList/" +
        selectedSchool
      )
        .then((res) => res.json())
        .then((data) => {
          if (Array.isArray(data)) {
            setCourses(data);
          } else if (data.data && Array.isArray(data.data)) {
            setCourses(data.data);
          } else {
            setCourses([]);
          }
        })
        .catch((err) => console.error("Error fetching courses:", err));
    } else {
      setCourses([]);
    }
  }, [selectedSchool]);

  // Handle form submit
  const handleSubmit = (e) => {
    e.preventDefault();
    if (selectedCourse) {
      // Open URL with only the course name
      const formattedCourse = selectedCourse
        .toLowerCase()
        .replace(/\s+/g, "-"); // optional: SEO friendly
      window.open(`/course-details/${formattedCourse}`, '_blank');
    }
  };

  return (
    <section className="programs-section ptb-50 bg-coursefinder">
      <div className="container-xxl ">
        <h2 className="modern-title text-center text-white">
          Search For Courses
        </h2>
        <div>
          <Form id="course-search-form" onSubmit={handleSubmit}>
            <Row className="g-4">
              {/* School Dropdown */}
              <Col md={5}>
                <Form.Group>
                  <Form.Label className="fw-semibold text-white mb-2">
                    Select School
                  </Form.Label>
                  <div className="input-group">
                    <Form.Select
                      className="border-start-0 py-3"
                      id="school"
                      name="school"
                      value={selectedSchool}
                      onChange={(e) => setSelectedSchool(e.target.value)}
                    >
                      <option value="">Select School</option>
                      {schools.map((school) => (
                        <option key={school.name} value={school.name}>
                          {school.title}
                        </option>
                      ))}
                    </Form.Select>
                  </div>
                </Form.Group>
              </Col>

              {/* Course Dropdown */}
              <Col md={5}>
                <Form.Group>
                  <Form.Label className="fw-semibold text-white mb-2">
                    Select Course
                  </Form.Label>
                  <div className="input-group">
                    <Form.Select
                      className="border-start-0 py-3"
                      id="course"
                      name="course"
                      value={selectedCourse}
                      onChange={(e) => setSelectedCourse(e.target.value)}
                    >
                      <option value="">Select Course</option>
                      {courses.map((course) => (
                        <option key={course.name} value={course.name}>
                          {course.title}
                        </option>
                      ))}
                    </Form.Select>
                  </div>
                </Form.Group>
              </Col>

              {/* Submit Button */}
              <Col md={2} className="d-flex align-items-end">
                <Button
                  variant="blue"
                  type="submit"
                  className="w-100 py-3 fw-semibold"
                  size="lg"
                >
                  Submit
                </Button>
              </Col>
            </Row>
          </Form>
        </div>
      </div>
    </section>
  );
};

export default CourseFinderHome;
